import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import css from './Select.module.scss';

interface Props extends React.HTMLProps<HTMLSelectElement> {
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  selected: boolean;
}

const Select = ({
  className,
  children,
  name,
  value,
  onChange,
  selected,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(
    css.Select,
    { [css.isSelected]: selected },
    className,
  );

  return (
    <select className={classes} name={name} value={value} onChange={onChange}>
      <option value={''} className={css.Select__Placeholder}>
        {intl.formatMessage({ id: 'select.pleaseSelect' })}
      </option>
      {children}
    </select>
  );
};

export default Select;
